<div class="spinner-container" *ngIf="isLoading" [ngStyle]="{'background-color': backgroundColor}">
    <div style="width: 108px;height: 44px;background-color: #00893d;display: flex;align-items: center;justify-content: center;">
      <img class="rotateCss" src="../../../../assets/icons/loading.svg">
      <div class="loadingText">Loading...</div>
    </div>
</div>
